import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken from 'lib/authentication/GetToken'

const axiosRequest = () => {
  const params = {
    token: getToken(),
  }

  return AxiosInitializer({
    ...params,
  })
}

export const sendInvite = async (email: string) => {
  const URL = `/site_users/invite`

  return await axiosRequest()
    .post(URL, {
      data: {
        attributes: { email },
      },
    })
    .catch((err) => err)
}
